export default __webpack_public_path__ + "static/media/spin-wheel-effect.af5acab4.png";